import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../index';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getUserDistanceDimensions = createSelector(
  getActiveComponentDesign,
  (state: RootState) => state.localUserDimensions,
  (state: RootState) => state.application.inDimensionMode,

  (activeComponentDesign, localUserDimensions, inDimensionMode) => {
    if (activeComponentDesign === null) return [];

    return inDimensionMode
      ? activeComponentDesign.userDistanceDimensions.concat(Object.values(localUserDimensions))
      : activeComponentDesign.userDistanceDimensions;
  },
);
